<template>
  <div
    class="card-header widget-card-header d-flex align-items-center position-relative"
    :class="!swiperIsActive ? 'visible' : 'hidden'"
  >
    <!-- Left area -->
    <div class="position-absolute start-0 mx-8">
      <slot name="left">
        <button
          v-if="onBack"
          ref="backButton"
          class="btn btn-link"
          @click="onBack"
        >
          <i class="bi-chevron-left fs-5 text-primary"></i>
          <span class="text-primary" :class="isOverlapping ? 'opacity-0' : ''">
            {{ backText }}
          </span>
        </button>
      </slot>
    </div>

    <!-- Center area (stays truly centered) -->
    <div
      ref="title"
      class="card-title position-absolute absolute-center d-flex align-items-center"
    >
      <slot name="center">
        <button
          v-if="navigation && navigation.left"
          class="btn btn-link"
          @click="() => navigation.left.onClick(navigation.left.value)"
        >
          <i :class="navigation.left.icon" class="fs-5 text-primary px-3"></i>
        </button>
        <h4 class="card-title m-0">
          {{ title }}
        </h4>
        <button
          v-if="navigation && navigation.right"
          class="btn btn-link"
          @click="() => navigation.right.onClick(navigation.right.value)"
        >
          <i :class="navigation.right.icon" class="fs-5 text-primary px-3"></i>
        </button>
      </slot>
    </div>

    <!-- Right area -->
    <div class="position-absolute end-0 mx-8">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  name: 'WidgetHeader',
  props: {
    swiperIsActive: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    onBackText: {
      type: String,
      default: null
    },
    onBack: {
      type: Function,
      default: () => null
    },
    navigation: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isOverlapping: false // Tracks if the h4 overlaps the button
    }
  },
  computed: {
    backText() {
      return this.onBackText || this.$t('resultDetails.backToResults')
    }
  },
  watch: {
    onBack() {
      nextTick(() => {
        // Wait for DOM to update before checking overlap
        this.checkOverlap()
      })
    },
    title() {
      nextTick(() => {
        // Wait for DOM to update before checking overlap
        this.checkOverlap()
      })
    }
  },
  mounted() {
    this.checkOverlap()
    window.addEventListener('resize', this.checkOverlap)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkOverlap)
  },
  methods: {
    checkOverlap() {
      if (this.$refs.title) {
        const titleRect = this.$refs.title.getBoundingClientRect()
        const buttonRect = this.$refs.backButton?.getBoundingClientRect()
        if (buttonRect) {
          this.isOverlapping = buttonRect.right > titleRect.left
        } else {
          this.isOverlapping = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.absolute-center {
  left: 0;
  right: 0;
  margin: auto !important;
  width: fit-content;
}
.widget-card-header {
  transition:
    height 0.1s ease-in-out,
    min-height 0.1s ease-in-out;
  > button,
  > div {
    transition: opacity 0.2s ease-in-out;
    opacity: 1;
  }
  &.hidden {
    border: none;
    min-height: 0px;
    height: 0px;
    > button,
    > div {
      opacity: 0;
    }
  }
}
</style>
